// eslint-disable-next-line import/order
import './polyfills';

import ReactDOM from 'react-dom';

import { RootConfig } from '../types/config.types';

import { App } from './App';
import { ReactConfigLoader } from './libs';

import './assets/styles/styles.scss';

// eslint-disable-next-line unicorn/prefer-top-level-await
ReactConfigLoader.init().then((config: RootConfig) => {
  ReactDOM.render(<App config={config} />, document.querySelector('#root'));
});
